import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth/auth';
import braintree from './braintree/braintree';
import coupons from './braintree/coupons';
import chat from './game/chat';
import game from './game/game';
import display from './display/display';
import flash from './flash/flash';
import narrative from './game/narrative';
import tooltip from './game/tooltip';
import socketio from './game/socketio';
import dashboards from './dashboards/dashboards';
import dashboardProfiles from './dashboards/dashboard-profiles';
import bladeAssets from './blade/assets';
import bladeChallenges from './blade/challenges';
import bladeEventPools from './blade/event-pools';
import bladeCharacters from './blade/characters';
import bladeCharacterTree from './blade/character-tree';
import bladeClasses from './blade/classes';
import bladeEnvironments from './blade/environments';
import bladeLti from './blade/lti';
import bladeSignInConfigs from './blade/signin-config';
import bladeSupportTickets from './blade/support-tickets';
import bladeGames from './blade/games';
import bladeGameSets from './blade/gamesets';
import bladeGroups from './blade/groups';
import bladeIndividualDecisions from './blade/individual-decisions';
import bladeMetrics from './blade/metrics';
import bladeOutros from './blade/outros';
import bladeRegistrationLinks from './blade/registration-link';
import bladeRoles from './blade/roles';
import bladeTeamDecisions from './blade/team-decisions';
import bladeUsers from './blade/users';
import bladeArticles from './blade/articles';
import bladeArticleCategories from './blade/article-categories';
import bladeVoiceLines from './blade/voice-lines';
import bladeDataTableView from './blade/data-table-view';
import bladeDeepDelete from './blade/deep-delete';
import lti from './lti/lti';
import audio from './audio/audio-setting';
import sound from './audio/sound';

import { connectAPIInstanceToStore } from '../axios-config';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    braintree,
    coupons,
    chat,
    game,
    display,
    flash,
    narrative,
    tooltip,
    socketio,
    dashboards,
    dashboardProfiles,
    bladeAssets,
    bladeChallenges,
    bladeEventPools,
    bladeCharacters,
    bladeCharacterTree,
    bladeClasses,
    bladeEnvironments,
    bladeLti,
    bladeSignInConfigs,
    bladeSupportTickets,
    bladeGames,
    bladeGameSets,
    bladeGroups,
    bladeIndividualDecisions,
    bladeMetrics,
    bladeOutros,
    bladeRegistrationLinks,
    bladeRoles,
    bladeTeamDecisions,
    bladeUsers,
    bladeArticles,
    bladeArticleCategories,
    bladeVoiceLines,
    bladeDataTableView,
    bladeDeepDelete,
    lti,
    sound,
    audio
  }
});

connectAPIInstanceToStore(store);

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js